//@ts-nocheck
import {Guid} from "guid-typescript";

export function doEventsUseHighResTimeStamps(context): boolean {
  let usesHighResTimeStamps: boolean;
  // If the performance API isn't even available, I assume events will not
  // use high res time stamps.
  if (!('performance' in context)) {
    usesHighResTimeStamps = false;
    return usesHighResTimeStamps;
  }

  // Check if the browser supports CustomEvents.
  const hasCustomEvent = 'CustomEvent' in context &&
    (typeof context.CustomEvent === 'function' || context.CustomEvent.toString().indexOf('CustomEventConstructor') > -1);

  // Create an event and compare its timestamps to the value returned by
  // performance.now(). If the event is using old timestamps, its origin
  // is going to be very far and hence, its timestamps will be much much
  // greater than performance.now().
  const testTimeStamp = hasCustomEvent ? new context.CustomEvent('test').timeStamp : context.document.createEvent('KeyboardEvent').timeStamp;

  usesHighResTimeStamps = testTimeStamp && testTimeStamp <= performance.now();
  return usesHighResTimeStamps;
}

export function createChannel(): string {
    return 'tx.' + Guid.create();
}

export interface Point {
  x: number,
  y: number
}

export function toPoint(x: number, y: number): Point {
  return {x: x, y: y};
}
